<template>
	<div>
		<div class="clear"></div>
		<div class="header">
			<div class="header line">
				<div>
				<div class="w1200 bc">
					<a class="logo fl" :href="indexUrl" title="Baomate"></a>
					<div class="search">
						<span class="ico"></span>
						<input class="text" type="text" v-model="sortParam" placeholder="Please enter key words">
						<button class="btn" @click="sortGoods()">Search</button>
						<!--<button class="btn" @click="sortShops()" style="margin-left: 3px;">搜店铺</button>-->
					</div>
					<div class="r-box fr">
						<div class="mycart" v-on:click="toShopCart"  @mouseenter="shopCarShow()" @mouseleave="shopCarHide()">
							<i class="ico-cart" ></i>
							My Shopping Cart
							<i class="ico-r"></i>
							<div class="goods-list none" style="display: none;">
								<div class="spacer"></div>
								<!--没选商品-->
								<div v-if="shoppingCartNum == 0" class="no-goods">
									<img src="../../static/images/settleup-nogoods.png" width="57" height="49">Your Shopping Cart is empty.
								</div>
								<!--已选商品-->
								<div v-if="shoppingCartNum > 0" class="mylist">
									<h4>Latest additions </h4>
									<ul>
										<li class="li-2" v-for="(bo,index) in boList" v-bind:id="bo.goodsCode+'_cart_pro'" >
											<a class="fl spic" v-on:click="toDetail(bo.goodsCode)" ><img v-bind:src="bo.imgSmall" width="50" height="50"></a>
											<p class="name">
												<a  v-on:click="toDetail(bo.goodsCode)"><span name="goodsName">{{ bo.goodsNameEn }}</span><span v-if="bo.specNameEn!=''">【{{ bo.specNameEn }}】</span></a> &nbsp;&nbsp;&nbsp;<span style="color: #f60;">Number：{{ bo.goodsNumber }}</span>
											</p>
											<p class="other"><span>￥{{ bo.unitPrice  }}</span><br>
												<a class="del"  v-on:click="deleteGoods(bo.id,bo.goodsCode,index)">Delete</a>
											</p>
										</li>
									</ul>
									<div class="fbar"><span class="fl ml10">{{ count }}item　total<b>￥ {{ sumMoney }}</b></span>
										<a class="fr gobuy"  v-on:click="toShopCart">Go to the shopping cart</a>
									</div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import API from "../../static/api/api.js"
	import {getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,getIndexUrl,getCmsUrl,getEmallUrl,getUcUrl} from "../../static/js/emallUtils.js"
	import Vue from 'vue'
	import VueResource from 'vue-resource';
	import VueRouter from 'vue-router' 
	Vue.use(VueRouter)
	Vue.use(VueResource);
	
	export default {
		name: 'emallheader',
		data() {
			return {
isLogin:false,
				shoppingCartNum:0,
				boList:[],
				count:0,
				goodsImgs:[],
				sumMoney:0,
				sortParam:'',
				carIsShow:'',
				indexUrl:'',
				orderUrl:'',
				allCount:0,
				payCount:0,
				putCount:0,
				receiveCount:0,
				sendCount:0,
				closeCount:0
			}
		},
		methods:{
			changeParam:function(para){
				this.sortParam=para;
			},
			orderShow:function(){
				jQuery(".orders-list").show();
			},
			orderHide:function(){
				jQuery(".orders-list").hide();
			},
			goOrder:function(tradeStatus){
				var account = localStorage.getItem("account");
				if(account != undefined && account != ""){
					window.location.href=this.orderUrl+"?tradeStatus="+tradeStatus;
				}else{
					window.location.href=getUcUrl()+'/login.htm';
				}
			},
			shopCarShow:function(){
				jQuery(".goods-list").show();
			},
			shopCarHide:function(){
				jQuery(".goods-list").hide();
			},
			sortGoods:function(){
				this.$router.push({ name: 'goodsList', query:{sortParam:this.sortParam}});
				this.$emit('input', this.sortParam);
			},
			sortShops:function(){
				this.$router.push({ name: 'shopsList', query:{sortParam:this.sortParam}});
			},
			getOrderCount:function(shopCode){
        		var that=this;
        		API.getOrderCount(function(ret){
        			if(ret.code == "success"){
        				that.allCount = ret.data.allCount;
        				that.payCount = ret.data.payCount;
        				that.putCount = ret.data.putCount;
        				that.receiveCount = ret.data.receiveCount;
        				that.sendCount = ret.data.sendCount;
        				that.closeCount = ret.data.closeCount;
        			}
        		})
        	},
			
			getShoppingCartNum:function(shopCode){
        		var that=this;
        		API.getShoppingCartNum(function(ret){
        			if(ret.code == "success"){
        				that.shoppingCartNum = ret.data.shoppingCartNum;
        			}
        		})
        	},
        	getShoppingCartList:function(){
        		var that=this;
        		API.getShoppingCartList(function(ret){
					 if(ret.code == "success"){
					 	that.boList = ret.data.boList;
					 	var totalCount = 0;
					 	var bos = new Array();
					 	bos = ret.data.boList;
					 	var money = 0;
					 	for(var i =0; i<bos.length;i++){
					 		var imgSmall = bos[i].imgSmall;
			                    if(imgSmall.indexOf(";")!=-1){
			                    	imgSmall=imgSmall.split(";")[0];
			                    }
					 		bos[i].imgSmall = getImgUrl()+"/upload/show.htm?filePath="+imgSmall;
					 		bos[i].unitPrice = bos[i].unitPrice / 100;
					 		money = money + bos[i].unitPrice * bos[i].goodsNumber;
					 		totalCount = totalCount + bos[i].goodsNumber;
					 	}
					 	that.sumMoney = money;
					 	that.count = totalCount;
					 }
        		})
        	},
        	deleteGoods:function(id,goodsCode,index){
        		var that=this;
        		API.deleteGoods(id,goodsCode, function(ret){
        			if(parseResult(ret, null, false)) {
//						jQuery("#" + goodsCode + "_cart_pro").remove();
						that.boList.splice(index, 1);
						that.getShoppingCartNum();
					}
        		})
        	},
        	toDetail:function(goodsCode) {
				this.$router.push({ path: '/goodsDetails', query:{goodsCode:goodsCode}});
				window.location.reload();
			},
			toShopCart:function(){
				this.$router.push({path:'/shopCart'});
			}
		},mounted(){
			this.indexUrl = getIndexUrl();
			this.orderUrl = getEmallUrl() + '/orderManage/myOrderList.htm';
			this.getShoppingCartNum();
			this.getShoppingCartList();
			this.getOrderCount();
			var account = localStorage.getItem("account");
			if(account != undefined && account != ""){
				this.isLogin = true;
			}
		}
	}
	
</script>


// WEBPACK FOOTER //
// src/components/Header.vue